import DashBoardSubscriptionRequests from './DashBoardSubscriptionRequests.container';

export default DashBoardSubscriptionRequests;
